import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useQuery } from "react-query";
import CField from "$forms/CField";
import GenericSelect from "$forms/GenericSelect";
import { EntreprisesServices } from "$services";
import { getCoordinators } from "$services/Coordinators.service";
import { CacheInvalidationAction } from "$utils/cache";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import { useDockyardStyles } from "../styles";

export const ApproverSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const classes = useDockyardStyles();
  const { currentCompany } = useDockyardFormContext();

  const filters = useMemo(
    () => ({ companyId: currentCompany, isActive: true }),
    [currentCompany]
  );

  const { data: companyApprovers = [], isLoading: isLoadingCompany } = useQuery(
    {
      queryKey: [CacheInvalidationAction.GET_USERS, filters],
      queryFn: () => EntreprisesServices.gethUsersByCompany(currentCompany),
      enabled: !!currentCompany,
      select: (response) =>
        (response.data || []).filter((u: any) => u.isApprover),
      staleTime: 5 * 60 * 1000,
    }
  );

  const { data: coordinators = [], isLoading: isLoadingCoordinators } =
    useQuery({
      queryKey: [CacheInvalidationAction.GET_COORDINATORS],
      queryFn: () => getCoordinators({ rowsPerPage: 1000 }),
      select: (response) => response?.data || [],
      staleTime: 5 * 60 * 1000,
    });

  const approvers = useMemo(() => {
    const seen = new Set<string>();
    return [...companyApprovers, ...coordinators].filter((u: any) => {
      if (seen.has(u.id)) return false;
      seen.add(u.id);
      return true;
    });
  }, [companyApprovers, coordinators]);

  const isLoading = isLoadingCompany || isLoadingCoordinators;

  const placeholder = !currentCompany
    ? "Vous devez d'abord sélectionner une entreprise"
    : approvers.length === 0 && !isLoading
    ? "Aucun approbateur disponible"
    : "Sélectionnez un approbateur";

  return (
    <div className={classes.newFormFieldsRow}>
      <CField
        control={control}
        name="approverId"
        error={errors.approverId}
        rules={{ required: "L'approbateur est requis" }}
      >
        {(props: any) => (
          <GenericSelect
            {...props}
            valueKey="id"
            label="Approbateur *"
            placeholder={placeholder}
            disabled={!currentCompany || isLoading}
            options={approvers}
            getOptionLabel={(option: any) =>
              `${option.firstname} ${option.lastname?.toUpperCase()}`
            }
          />
        )}
      </CField>
    </div>
  );
};
